import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "App/utils/helpers";
import { status_pengerjaan } from "../HelpDesk/helpers";
export default function FormFilter({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
  withStatus = true,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const gudang = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/list",
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  const vendor = useSelectOption(
    true,
    "/wmsMasterAsset/vendor/list",
    TYPE_INSTANCE4
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              type="number"
              name="id"
              label="ID"
              id="id_request"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="ID"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="number"
              name="id_helpdesk"
              label="ID"
              id="id_helpdesk"
              value={formFilter.id_helpdesk_header}
              onChange={handleChange("id_helpdesk_header")}
              placeholder="ID Help Desk"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="user_request"
              label="USER REQUEST"
              id="user_request"
              value={formFilter.user_request}
              onChange={handleChange("user_request")}
              placeholder="User Request"
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="status_service"
              label="STATUS"
              id="status_service"
              withSearch={true}
              disabled={!withStatus}
              value={formFilter.status_service}
              labelValue={formFilter.nama_status_service}
              onChange={(e) => {
                if(withStatus){
                    if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    status_service: "",
                    nama_status_service: "Pilih Status",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    status_service: e.value,
                    nama_status_service: e.label,
                  });
                }
                }else{
                
                }
                
              }}
              data={status_pengerjaan}
              error={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="id_unit"
              label="UNIT"
              id="id_unit"
              withSearch={true}
              value={formFilter.unit_id}
              labelValue={formFilter.unit}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    unit_id: "",
                    unit: "Pilih Unit",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    unit_id: e.value,
                    unit: e.label,
                  });
                }
              }}
              data={unit}
              error={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="id_gudang"
              label="GUDANG"
              id="id_gudang"
              withSearch={true}
              value={formFilter.gudang_id}
              labelValue={formFilter.gudang}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_id: "",
                    gudang: "Pilih Gudang",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_id: e.value,
                    gudang: e.label,
                  });
                }
              }}
              data={gudang}
              error={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="vendor"
              label="VENDOR"
              id="vendor"
              value={formFilter.vendor_id}
              labelValue={formFilter.nama_vendor}
              withSearch={true}
              onChange={(e) =>
                isNull(e)
                  ? setFormFilter({
                      ...formFilter,
                      vendor_id: "",
                      nama_vendor: "Pilih Vendor",
                    })
                  : setFormFilter({
                      ...formFilter,
                      vendor_id: e?.value,
                      nama_vendor: e?.label,
                    })
              }
              data={vendor}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="pic"
              label="PIC"
              id="pic"
              value={formFilter.pic}
              onChange={handleChange("pic")}
              placeholder="PIC"
            />
          </Grid>
          <Grid item sm={6}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AWAL
            </label>
            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tglAwal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                });
              }}
              placeholderText="Tanggal"
            />
          </Grid>
          <Grid item sm={6}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AKHIR
            </label>
            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tglAkhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                });
              }}
              placeholderText="Tanggal"
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
